import React from "react";
import { Icon } from "@/components/Icon";

/* MobileTabBar — faithful port of the design's PMTabs component
   (.design-handoff/source/raw/PMTabs.dc.html). Five tabs:
     Home · Casino · Sports · My Bets(badge) · Menu
   Home/Casino/Sports/My Bets navigate; Menu opens the menu sheet ("Menu, which
   IS a tab"). Active uses the "-fill" icon variant (except menu) + green glyph +
   white label; inactive = #71717A. The iOS home-indicator bar is OS chrome, so
   we use real safe-area padding instead. The docked slip pill renders ABOVE this
   bar (see DockedSlipPill) and is mounted by MobileShell. */

const TABS = [
  { key: "home", label: "Home", icon: "home", to: "/" },
  { key: "casino", label: "Casino", icon: "casino", to: "/casino" },
  { key: "sports", label: "Sports", icon: "sportsbook", to: "/sportsbook" },
  { key: "bets", label: "My Bets", icon: "mybets", to: "/my-bets", badge: true },
  { key: "menu", label: "Menu", icon: "menu", menu: true },
];

export default function MobileTabBar({ active, onNavigate, onMenu, betCount = 0 }) {
  return (
    <nav
      aria-label="Primary"
      style={{
        position: "fixed", left: "50%", transform: "translateX(-50%)", bottom: 0, zIndex: 40,
        width: "100%", maxWidth: 480,
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        background: "rgba(12,12,14,.9)", backdropFilter: "blur(24px)", WebkitBackdropFilter: "blur(24px)",
        boxShadow: "0 -1px 0 rgba(255,255,255,.06)",
      }}
    >
      <div style={{ height: 64, padding: "6px 6px 0", display: "grid", gridTemplateColumns: "repeat(5,minmax(0,1fr))" }}>
        {TABS.map((t) => {
          const on = active === t.key;
          const iconName = on && !t.menu ? `${t.icon}-fill` : t.icon;
          const showBadge = t.badge && betCount > 0;
          return (
            <button
              key={t.key}
              type="button"
              aria-label={t.label}
              aria-current={on ? "page" : undefined}
              onClick={() => (t.menu ? onMenu?.() : onNavigate?.(t.to))}
              style={{ height: 50, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4, background: "none", border: 0, cursor: "pointer" }}
            >
              <span style={{ position: "relative", width: 26, height: 26, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon name={iconName} size={24} style={{ color: on ? "#00D632" : "#71717A" }} />
                {showBadge && (
                  <span
                    className="m-tnum"
                    style={{ position: "absolute", top: -3, right: -9, minWidth: 17, height: 17, boxSizing: "border-box", padding: "0 4px", borderRadius: 999, background: "#F4F4F5", color: "#0A0A0A", boxShadow: "0 0 0 2px #0C0C0E", font: "800 10px/17px 'Outfit'", textAlign: "center" }}
                  >
                    {betCount > 99 ? "99+" : betCount}
                  </span>
                )}
              </span>
              <span style={{ font: `${on ? 700 : 600} 11px 'Outfit'`, color: on ? "#FFFFFF" : "#71717A" }}>{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
